import { BaseUseCase } from "../UseCaseBase";
class exchangeHolidaysUseCase extends BaseUseCase {
    constructor(FooterRepository) {
        super();
        this.FooterRepository = FooterRepository;
    }
    fetchResult() {
        return this.FooterRepository.getExchangeHolidays();
    }
}
export default exchangeHolidaysUseCase;
